import { useSearchParams } from 'react-router-dom';
import { ContractsGrid } from 'components/Contracts/contracts.grid';
import { Heading } from 'shared/ui/list-page-heading';
import { useTitleHook } from 'hooks/page-title.hook';
import { useContractsList } from 'entities/contract/lib';
import { usePagingParams } from 'shared/hooks/paging-params';
import { CONTRACT_TYPE_CLIENT, CONTRACT_TYPE_SUPPLIER } from '@sr/dto';
import { Box } from '@mui/material';
import { ContractsFilter } from 'features/contract/contracts-filter';

const title = 'Договоры';

const ContractsListPage = () => {
  useTitleHook(title);

  const [paging, setPaging] = usePagingParams();
  const [searchParams] = useSearchParams();
  const type = Number(searchParams.get('type')) === CONTRACT_TYPE_SUPPLIER ? CONTRACT_TYPE_SUPPLIER : CONTRACT_TYPE_CLIENT;
  const filterString = Number(searchParams.has('type')) ? searchParams.toString() : `${searchParams.toString()}&type=${CONTRACT_TYPE_CLIENT}`;
  const contracts = useContractsList(paging, filterString);

  return (
    <>
      <Heading sx={{ mb: 1 }} title={title} />

      <Box my={1}>
        <ContractsFilter />
      </Box>
      <ContractsGrid contracts={contracts.collection} paging={paging} onChangePaging={setPaging} contractType={type} />
    </>
  );
};

export default ContractsListPage;
